<template>
	<div>
		<vx-card title="Modules">
			<div class="vx-row w-full">
				<div class="vx-col w-full mb-base">
					Modules maken het mogelijk nog meer uit Piqwise te halen. Ze bieden bijvoorbeeld koppelingen met je webshop, boekhouding of verzender. Staat jouw gewenste
					module er niet tussen? Neem dan gerust contact met ons op om je wensen kenbaar te maken!
				</div>
			</div>

			<div class="vx-row w-full">
				<div class="vx-col w-full sm:w-1/2 lg:w-1/3 mb-base">
					<module-card
						type="accounting"
						:image="require(`@/assets/images/modules/overview/invoices.jpg`)"
						name="Piqwise facturen"
						description="Facturen met één klik aanmaken, verzenden, downloaden of automatisch verzenden."
						url-name="moduleAccountingInvoices"
					/>
				</div>
				<div class="vx-col w-full sm:w-1/2 lg:w-1/3 mb-base">
					<module-card
						type="accounting"
						:image="require(`@/assets/images/modules/overview/moneybird.jpg`)"
						name="Moneybird"
						description="Facturen met één klik aanmaken, verzenden of downloaden."
						url-name="moduleAccountingMoneybird"
					/>
				</div>
				<div class="vx-col w-full sm:w-1/2 lg:w-1/3 mb-base">
					<module-card
						type="accounting"
						:image="require(`@/assets/images/modules/overview/eboekhouden.jpg`)"
						name="e-Boekhouden"
						description="Facturen met één klik aanmaken, verzenden of downloaden."
						url-name="moduleAccountingEboekhouden"
					/>
				</div>

				<div class="vx-col w-full sm:w-1/2 lg:w-1/3 mb-base">
					<module-card
						type="webshop"
						:image="require(`@/assets/images/modules/overview/bol.com.jpg`)"
						name="Bol.com"
						description="Bestellingen ontvangen en verwerken in piqwise. Product aanbod beheren via piqwise."
						url-name="moduleWebshopBol"
					/>
				</div>

				<div class="vx-col w-full sm:w-1/2 lg:w-1/3 mb-base">
					<module-card
						type="webshop"
						:image="require(`@/assets/images/modules/overview/lightspeed.jpg`)"
						name="Lightspeed"
						description="Bestellingen ontvangen en verwerken in piqwise."
						url-name="moduleWebshopLightspeed"
					/>
				</div>

				<div class="vx-col w-full sm:w-1/2 lg:w-1/3 mb-base">
					<module-card
						type="shipping"
						:image="require(`@/assets/images/modules/overview/sendcloud.jpg`)"
						name="Sendcloud"
						description="Bestellingen met een klik verzenden via Sendcloud. Verzendlabels downloaden en afdrukken."
						url-name="moduleShipmentSendcloud"
					/>
				</div>

				<div class="vx-col w-full sm:w-1/2 lg:w-1/3 mb-base">
					<module-card
						type="printing"
						:image="require(`@/assets/images/modules/overview/dymo.jpg`)"
						name="Dymo"
						description="Adres-, retour-, product- en ean-labels printen met één klik."
						url-name="modulePrintingDymo"
					/>
				</div>

				<div class="vx-col w-full sm:w-1/2 lg:w-1/3 mb-base">
					<module-card
						type="discount"
						:image="require(`@/assets/images/modules/overview/promotion.jpg`)"
						name="Terugkerende korting"
						description="Stel hier automatische kortingen in voor je complete aanbod. De kortingen kunnen wekelijks of maandelijks terugkeren."
						url-name="modulePromotion"
					/>
				</div>

			<div class="vx-col w-full sm:w-1/2 lg:w-1/3 mb-base">
				<module-card
					type="inventory"
					:image="require(`@/assets/images/modules/overview/stockpools.jpg`)"
					name="Voorraad pools"
					description="Beheer verkoop vanuit centrale voorraad verdeeld over meerdere EAN en synchroniseer deze automatisch met je webshop."
					url-name="moduleInventoryPools"
					beta
				/>
			</div>
			</div>
		</vx-card>
	</div>
</template>

<script>
import ModuleCard from '@/views/modules/moduleCard';
import {mapGetters} from 'vuex';

export default {
	components: {ModuleCard},
	computed: {
		...mapGetters({
			user: 'userStore/user'
		}),
	},
}
</script>